
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { PlotExpenseForm } from "./PlotExpenseForm";
import { ScrollArea } from "@/components/ui/scroll-area";

interface PlotExpenseDialogProps {
  plotId: string;
  onExpenseCreated: () => void;
}

export const PlotExpenseDialog = ({ plotId, onExpenseCreated }: PlotExpenseDialogProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button className="w-full h-12">
          <PlusIcon className="h-4 w-4 mr-2" />
          Nuevo gasto de parcela
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] p-0">
        <DialogHeader className="p-6 pb-2">
          <DialogTitle className="text-2xl">Nuevo gasto de parcela</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[calc(90vh-80px)]">
          <div className="p-6 pt-2">
            <PlotExpenseForm
              plotId={plotId}
              onExpenseCreated={onExpenseCreated}
              onClose={() => setIsDialogOpen(false)}
            />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
